import React from 'react'
import { Modal, Table } from 'antd'

const BatchConfirmModal = ({ visible, onCancel, onOk, pendingEdits }) => {
  const dataSource = Object.entries(pendingEdits).map(([key, value]) => ({
    key,
    prop: key,
    description: value
  }))

  const columns = [
    {
      title: 'Prop',
      dataIndex: 'prop',
      key: 'prop',
      width: 150
    },
    {
      title: 'New Description',
      dataIndex: 'description',
      key: 'description'
    }
  ]

  return (
    <Modal
      maskClosable={false}
      visible={visible}
      title="Confirm Bulk Generation"
      onCancel={onCancel}
      onOk={onOk}
      okText="Confirm & Regenerate"
      cancelText="Wait, I'm not done"
      width={700}
      centered
    >
      <p>
        The following props have modified descriptions. Clicking confirm will
        trigger a batch regeneration for all of them.
      </p>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        size="small"
        bordered
      />
      <p style={{ marginTop: 16, fontWeight: 500, color: '#fa8c16' }}>
        Note: Existing images for these props will be replaced.
      </p>
    </Modal>
  )
}

export default BatchConfirmModal
